import { render, staticRenderFns } from "./AadCallback.vue?vue&type=template&id=32553ed2&scoped=true"
import script from "./AadCallback.vue?vue&type=script&lang=js"
export * from "./AadCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32553ed2",
  null
  
)

export default component.exports